export const USER_ROLE = {
  User: "user",
  Guest: "guest",
  Premium: "premium",
} as const;
